import { getLabel } from "../data/labels";
import { getDaysLabels, getMonthsLabels } from "./utils";

// Funzione per formattare la data
export function formatDate(dateString) {
    if (dateString == null) {
        return '';
    }
    
    const daysOfWeek = getDaysLabels();
    const months = getMonthsLabels();

    const date = new Date(
        dateString.slice(0, 4), 
        dateString.slice(4, 6) - 1, 
        dateString.slice(6, 8), 
        dateString.slice(9, 11), 
        dateString.slice(12, 14), 
        dateString.slice(15, 17) 
    );

    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const dateTimestamp = date.setHours(0, 0, 0, 0);
    const todayTimestamp = today.setHours(0, 0, 0, 0);
    const tomorrowTimestamp = tomorrow.setHours(0, 0, 0, 0);

    if (dateTimestamp === todayTimestamp) {
        return getLabel('general.today');
    } else if (dateTimestamp === tomorrowTimestamp) {
        return getLabel('general.tomorrow');
    } else {
        const dayOfWeek = daysOfWeek[date.getDay()];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${dayOfWeek} ${day} ${month} ${year}`;
    }
}
const ParseData48H = ({ dateString }) => {
    const formattedDate = formatDate(dateString);
    return <div>{formattedDate}</div>;
};

export default ParseData48H;